import { useQuery } from "@tanstack/react-query";

import { getProduct } from "../../api/catalog";

/** useProduct — карточка товара витрины (docs/07-miniapp-ux.md §2.3). 404 — товар недоступен. */
export function useProduct(id: string) {
  return useQuery({
    queryKey: ["product", id],
    queryFn: ({ signal }) => getProduct(id, signal),
    staleTime: 30_000,
  });
}
